module.exports = __webpack_public_path__ + "img/windowsStep1.cc34139d.png";